export default __webpack_public_path__ + "static/Real-Estate-iopsapps-e7fd3bdb45df1ed6bf5ee122e6a6d934.svg";